/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * Static class with util methods to format and convert values from metric to imperial systems.
 *
 * @class UnitFormatConverter
 * @extends L.Evented
 * @module Services
 */
define(['leaflet', '../config/unit/globalUnitService'], function(L, globalUnitService) {
    'use strict';
    var UnitFormatConverter;

    /**
     * Event fired when the global measurement unit is changed using the method
     * {{#crossLink "UnitFormatConverter/unitsScheme:method"}}{{/crossLink}}.
     *
     * @event change
     * @param {"metric"|"imperial"} newMeasurementUnit
     */

    /**
     * @ignore
     * @param {String} value Numeric value
     * @return {String}
     */
    function enforceLeadingZero(value) {
        return value < 10 ? '0' + value : value;
    }

    /**
     * Convert a distance in meters to yards.
     * @method convertMetersToYards
     * @param {Number} distanceMeters
     * @return {Number}
     */
    function convertMetersToYards(distanceMeters) {
        return 1.0936133 * distanceMeters;
    }

    /**
     * @ignore
     * @param {Number} distanceMeters
     * @return {Number}
     */
    function convertMetricToMiles(distanceMeters) {
        return 0.000621371192 * distanceMeters;
    }

    /**
     * @ignore
     * @param {Number} distanceMeters
     * @return {String} Distance in miles or yards
     */
    function formatMetricAsImperialDistance(distanceMeters) {
        var yards = convertMetersToYards(distanceMeters),
            miles = convertMetricToMiles(distanceMeters);
        return miles < 1 ? Math.round(yards) + ' yd' : Math.round(miles * 10) / 10 + ' mi';
    }

    /**
     * @ignore
     * @param {Number} distanceMeters
     * @return {String} Distance in kilometers or meters
     */
    function formatAsMetricDistance(distanceMeters) {
        var distance = Math.round(distanceMeters);
        if (distance >= 1000) {
            return Math.round(distance / 100) / 10 + ' km';
        }
        return distance + ' m';
    }

    UnitFormatConverter = L.Evented.extend({
        /**
        * Convert a distance in yards to meters.

        * @method convertYardsToMeters
        * @param {Number} distanceYards Distance in yards
        * @return {Number}
        */
        convertYardsToMeters: function(distanceYards) {
            return Math.round(distanceYards / 1.0936133);
        },

        convertMetersToYards: convertMetersToYards,

        /**
         * Converts the given time in seconds to a string with the the format of 'HH h MM min' or 'MM min SS s'.
         *
         * HH - hours MM - minutes SS - seconds.
         *
         * @method formatTime
         * @param {Number} [seconds] Number of seconds
         * @return {String|undefined} Formatted time
         *
         * @example
         * ```javascript
         * tomtom.unitFormatConverter.formatTime(3600);  / returns 1 h 0 min
         * ```
         */
        formatTime: function(seconds) {
            var secondsNum, hours, minutes, secondsFormatted, minutesFormatted;
            if (seconds === undefined) {
                return undefined;
            }
            secondsNum = parseInt(seconds, 10);
            hours = Math.floor(secondsNum / 3600);
            minutes = Math.floor((secondsNum - hours * 3600) / 60);
            if (secondsNum < 60) {
                return secondsNum + ' s';
            }
            secondsNum %= 60;
            secondsFormatted = enforceLeadingZero(secondsNum);
            minutes %= 60;
            minutesFormatted = enforceLeadingZero(minutes);
            if (hours > 0) {
                return hours + ':' + minutesFormatted + ' h';
            }
            return minutes + ':' + secondsFormatted + ' min';
        },

        /**
         * Converts a date in the machine format to a more human readable form.
         *
         * Returns a formatted string created from the given date in UTC format.
         *
         * @method formatHourAndMinute
         * @param {String} [dateInMs] Date and time specified in the RFC-3339 format with an optional time zone offset
         * @return {String} Formatted time in hours and minutes
         *
         * @example
         * ```javascript
         * tomtom.unitFormatConverter.formatHourAndMinute('2016-03-01T15:45:58+01:00') // gives '3:45'
         * ```
         */
        formatHourAndMinute: function(dateInMs) {
            var date = new Date(dateInMs);
            var hour = date.getHours(),
                minute = date.getMinutes();
            return hour + ':' + enforceLeadingZero(minute);
        },

        /**
         * Converts distance in meters to a proper display format in SI or imperial units.
         *
         * @method formatDistance
         * @param {Number} distanceMeters Distance in meters
         * @param {Boolean} [imperial=false] Use imperial units
         * @return {String} Aformatted distance
         */
        formatDistance: function(distanceMeters, imperial) {
            if (distanceMeters === undefined) {
                return undefined;
            }
            if (imperial) {
                return formatMetricAsImperialDistance(distanceMeters);
            }
            return formatAsMetricDistance(distanceMeters);
        },

        /**
         * Gets ore sets the default units scheme for new widgets and services.
         *
         * @method unitsScheme
         * @param {"imperial"|"metric"} [newUnit] If isn't provided then
         *     this method will only return then current units scheme
         * @return {String} Current units scheme
         * @deprecated Please use <a href="../classes/tomtom.html#method_globalUnitService" class="alert-link">
         * tomtom.globalUnitService()</a> instead.
         */
        unitsScheme: function(newUnit) {
            console.warn('Deprecated. Please use unitService class.');
            if (!newUnit) {
                return globalUnitService.getCurrentUnit().getLabel();
            }

            globalUnitService.setCurrentUnit(newUnit);
            this.fire('change', {newScheme: newUnit});
            return newUnit;
        }
    });

    return new UnitFormatConverter();
});



// WEBPACK FOOTER //
// ./unitFormatConverter/unitFormatConverter.js